<template>
  <component :is="type" v-bind="linkProps(to, query)">
    <slot></slot>
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate';

export default {
  props: {
    to: {
      type: String,
      required: true
    },
    query: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 是否外链
    isExternal() {
      return isExternal(this.to);
    },
    // 动态组件
    type() {
      if (this.isExternal) {
        return 'a';
      }
      return 'router-link';
    }
  },
  methods: {
    // 链接参数
    linkProps(to, query) {
      if (this.isExternal) {
        return {
          href: to,
          target: '_blank',
          rel: 'noopener'
        };
      }
      return {
        to: {
          path: to,
          query: query ? { redirect: query } : {}
        }
      };
    }
  }
};
</script>